/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerListReportsQueryResponse, IncidentInvestigationControllerListReportsPathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerListReports";

function getIncidentInvestigationControllerListReportsUrl(id: IncidentInvestigationControllerListReportsPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/incident-agent/investigations/${id}/reports` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/reports}
 */
export async function incidentInvestigationControllerListReports(id: IncidentInvestigationControllerListReportsPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentInvestigationControllerListReportsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getIncidentInvestigationControllerListReportsUrl(id).url.toString(), ... requestConfig })  
  return res.data
}